import Eventify from './Eventify'
import { get } from './Utils'

export default class Component {
    static selector

    constructor(element, options = { render: true }) {
        this.$el = typeof element === 'string' ? get(element) : element
        this.$options = options
        this.$events = new Eventify()

        if (this.$el && !getComponentFromElement(this.$el)) {
            this.$el['__component__'] = this
            this.initialize()
        } else if (this.$options.render === false) {
            this.initialize()
        }
    }

    //--------------------------------------------------------------
    //  Lifecycle
    //--------------------------------------------------------------
    initialize() {}
    mount() {}
    destroy() {}

    //--------------------------------------------------------------
    //  Helpers
    //--------------------------------------------------------------

    $(selector) {
        return this.$el.querySelector(selector)
    }

    $$(selector) {
        return Array.from(this.$el.querySelectorAll(selector))
    }

    ref(selector) {
        return this.$el.querySelector(`[data-ref="${selector}"]`)
    }

    refs(selector) {
        return Array.from(this.$el.querySelectorAll(`[data-ref="${selector}"]`))
    }

    //--------------------------------------------------------------
    //  Events
    //--------------------------------------------------------------
    on(event, handler, once) {
        return this.$events.on(event, handler, once)
    }

    once(event, handler) {
        return this.$events.once(event, handler)
    }

    off(event, handler) {
        return this.$events.off(event, handler)
    }

    trigger(event) {
        return this.$events.trigger(event)
    }
}

//--------------------------------------------------------------
//  Create
//--------------------------------------------------------------
export const createComponents = (components) => {
    if (!components || !Object.keys(components).length) {
        console.warn(`Cannot create empty components`)
        return false
    }
    Object.values(components).forEach(
        (componentConstructor) => new componentConstructor()
    )
}

//--------------------------------------------------------------
//  SPA
//--------------------------------------------------------------
export const getComponentFromElement = (element) => element['__component__']

export const getComponentsFromElement = (context) => {
    if (typeof context === 'string') context = document.querySelector(context)
    return (context && context['__components__']) || []
}

export const createComponentInstance = (element, component) => {
    return component.prototype instanceof Component
        ? new component(element)
        : component(element)
}

export const destroyInstance = (element) => {
    const instance = getComponentFromElement(element)
    if (instance) {
        instance.destroy()
    }
}

export const loadComponents = (
    components = {},
    context = document.documentElement
) => {
    if (!components || !Object.keys(components).length) {
        console.warn(`Empty components passed to ${context}`)
        return
    }
    if (typeof context === 'string') context = document.querySelector(context)
    if (!context) {
        console.warn(`Empty context passed to ${context}`)
        return
    }

    if (!Array.isArray(context['__components__'])) {
        context['__components__'] = []
    }

    for (const [name, constructor] of Object.entries(components)) {
        if (!constructor.selector) continue

        Array.from(context.querySelectorAll(constructor.selector)).forEach(
            (element) => {
                // Continue if component already mounted
                if (getComponentFromElement(element)) {
                    console.trace('already mounted ', name, 'on', element)
                    console.log('already mounted ', name, 'on', element)
                } else {
                    element.setAttribute('data-component', name)
                    const instance = createComponentInstance(
                        element,
                        constructor
                    )
                    context['__components__'].push(instance)
                    instance.mount()
                }
            }
        )
    }
}

export const removeComponents = (context = document.documentElement) => {
    if (typeof context === 'string') context = document.querySelector(context)
    if (!context) {
        console.warn(`Empty context passed to ${context}`)
        return
    }
    Array.from(context.querySelectorAll('[data-component]')).forEach(
        (element) => {
            destroyInstance(element)
        }
    )
    if (Array.isArray(context['__components__'])) {
        context['__components__'].length = 0
    }
}
